import React, { useEffect, useState } from 'react';
import { Grid, Modal } from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import { getVendorList } from '../../apicalls/getVendorDetails';
import _ from 'lodash';
import { useRecoilState } from 'recoil';
import {
  additionalCostData,
  progressFlgState,
  workingBudgetData,
  workingBudgetVendor
} from '../../GlobalState';
import {
  ModalCancelButton,
  ModalDeleteButton,
  ModalSubmitButton
} from '../parts/cloudStorage/style/style';
import { TypeLayer, TypeVendorInfo } from '../../types/WorkingBudgetPage';
import { addVender } from '../../apicalls/WorkingBudgetPage';
import { recalculation } from '../../utils/WorkingBudgetPage';
import { NOT_LOGGED_IN } from '../../const/Const';

type TProps = {
  openSelectModal: boolean;
  setOpenSelectModal: React.Dispatch<React.SetStateAction<boolean>>;
  changeLoggedInData: (newData: string) => void;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSuccessMessage: React.Dispatch<React.SetStateAction<string>>;
  setOpenSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  workingBudgetId: number;
};

export const VenderSelectModal: React.FC<TProps> = (props: TProps) => {
  const {
    openSelectModal,
    setOpenSelectModal,
    changeLoggedInData,
    setErrorMessage,
    setOpen,
    setSuccessMessage,
    setOpenSuccess,
    workingBudgetId
  } = props;

  const classes = useStyles();
  const [additionalCost, setAdditionalCost] =
    useRecoilState(additionalCostData);
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);
  const [vendorList, setVendorList] = useState([]);
  const [vendorId, setVendorId] = useState<number>(0);
  const [vendor, setVendor] = useRecoilState(workingBudgetVendor);
  const [workingBudget, setWorkingBudget] = useRecoilState(workingBudgetData);

  useEffect(() => {
    getVendorList().then(data => {
      if (data.data === NOT_LOGGED_IN) {
        changeLoggedInData(NOT_LOGGED_IN);
      } else {
        if (typeof data.data === 'string') {
          setErrorMessage(data.data);
          setOpen(true);
        } else {
          const venderList = data.data;

          // venderオブジェクトからvendor_idを取得して配列を作成
          const vendorIdsToRemove = vendor?.map(
            (v: TypeVendorInfo) => v.vendor_id
          );

          // vendor_idが上記の配列に存在しないvenderListのアイテムのみを取得
          const filteredVenderList = venderList.filter(
            (item: any) => !vendorIdsToRemove?.includes(item.id)
          );

          setVendorList(filteredVenderList);
        }
      }
    });
  }, []);

  const addVendor = () => {
    setProgressFlg(true);
    const selectVendor: any = vendorList.find((v: any) => v.id == vendorId);
    const reqData = {
      vendor_id: vendorId,
      name: selectVendor.name,
      total: 0,
      additional_cost: 0
    };
    addVender(reqData, workingBudgetId)
      .then(data => {
        if (data.data === NOT_LOGGED_IN) {
          changeLoggedInData(NOT_LOGGED_IN);
        } else {
          if (typeof data.data === 'string') {
            setErrorMessage(data.data);
            setOpen(true);
          } else {
            const cloneWorkingBudget: TypeLayer | undefined =
              _.cloneDeep(workingBudget);
            const vender: TypeVendorInfo[] = data.data.venderList;
            cloneWorkingBudget &&
              recalculation(
                cloneWorkingBudget,
                vender,
                setWorkingBudget,
                setVendor,
                additionalCost
              );
            setSuccessMessage('業者の追加に成功しました。');
            setOpenSuccess(true);
            setOpenSelectModal(false);
          }
        }
      })
      .finally(() => setProgressFlg(false));
  };

  return (
    <Modal
      open={openSelectModal}
      onClose={() => setOpenSelectModal(false)}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.modal}
    >
      <Grid container className={classes.subpaper}>
        <Grid item xs={12} className={classes.container}>
          <div style={{ textAlign: 'center' }}>
            <h1 style={{ margin: 24, fontSize: 24 }}>業者を追加</h1>
          </div>
        </Grid>

        <div className={classes.body}>
          <div className={classes.select}>
            <label style={{ width: 100 }}>
              業者名<span style={{ color: 'red' }}>(必須)</span>
            </label>
            <select
              onChange={(e: any) => setVendorId(Number(e.target.value))}
              style={{ width: 300, height: 30 }}
            >
              <option value={0}>-</option>
              {vendorList &&
                vendorList.length > 0 &&
                vendorList.map((i: any, index) => (
                  <option value={i.id} key={index}>
                    {i.name}
                  </option>
                ))}
            </select>
          </div>
        </div>

        <Grid item xs={12} className={classes.modalFooter}>
          <ModalCancelButton
            variant='contained'
            onClick={() => {
              setOpenSelectModal(false);
            }}
          >
            キャンセル
          </ModalCancelButton>
          <ModalSubmitButton
            disabled={!vendorId}
            variant='contained'
            onClick={addVendor}
          >
            追加する
          </ModalSubmitButton>
        </Grid>
      </Grid>
    </Modal>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cancelButton: {
      backgroundColor: '#bdbdbd',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#cccccc',
        boxShadow: 3
      }
    },
    submitButton: {
      backgroundColor: '#007dff',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#2691ff',
        boxShadow: 3
      }
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    subpaper: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '50%',
      maxHeight: '90vh',
      overflowY: 'scroll'
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    body: {
      backgroundColor: theme.palette.background.paper,
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: 100
    },
    modalFooter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    },
    select: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    }
  })
);
